import { Sheet } from '@sunwebgroup/uds-ui/sheet'
import { useState } from 'react'
import { useIntl } from '@/intl'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { createPDPClickEvent } from '@/scopes/products/infrastructure/analytics'
import { Content } from './Content'

export function ReviewDetails({ isHeroSection = false, children }: React.PropsWithChildren<{ isHeroSection?: boolean }>) {
  const { sendEvent } = useAnalytics()
  const [showExtended, setShowExtended] = useState(false)

  const handleModalClose = () => {
    const nextOpen = !showExtended

    sendEvent(
      createPDPClickEvent({
        element: 'Bottom sheet',
        description: `${isHeroSection ? 'Top - ' : ''}${nextOpen ? 'Show more' : 'Hide'} information about the reviews`,
        result: `Modal with all reviews ${nextOpen ? 'opened' : 'closed'}`,
        type: 'Reviews extended modal',
      }),
    )

    setShowExtended(nextOpen)
  }

  const intl = useIntl()

  return (
    <Sheet.Root open={showExtended} onOpenChange={handleModalClose}>
      <Sheet.Trigger>
        {children}
      </Sheet.Trigger>
      <Sheet.Body side="bottom" hasPadding={false}>
        <Sheet.Header
          closeLabel={intl.formatMessage({ id: 'close' })}
          titleLabel={intl.formatMessage({ id: 'reviews_extended_heading' })}
        />
        <Sheet.Content>
          <Content />
        </Sheet.Content>
      </Sheet.Body>
    </Sheet.Root>
  )
}
